import { render, staticRenderFns } from "./PunchGame.vue?vue&type=template&id=6e21b601&scoped=true&"
import script from "./PunchGame.vue?vue&type=script&lang=js&"
export * from "./PunchGame.vue?vue&type=script&lang=js&"
import style0 from "./PunchGame.vue?vue&type=style&index=0&id=6e21b601&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21b601",
  null
  
)

export default component.exports